import React, { useEffect, useState } from "react";
import {
  Table,
  Card,
  Tooltip,
  Modal,
  Row,
  Col,
  Typography,
  Tag,
  Button,
  Descriptions,
  Form,
  Input,
  Select,
  InputNumber,
  notification,
  Upload,
} from "antd";
import { postReq } from "../api";
import { toastNotification } from "../utils/toasthelper";
import { PlusOutlined, UploadOutlined } from "@ant-design/icons";
import useUserDetails from "../utils/useUserDetails";
const { Title } = Typography;
const { Option } = Select;

const Candidate = () => {
  const [data, setData] = useState([]);
  const [visible, setVisible] = useState(false);
  const [modalData, setModalData] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [showApplyModal, setshowApplyModal] = useState(false);
  const [applyRecord, setApplyRecord] = useState(null);
  const [isSearch, setIsSearch] = useState(true);
  const [techNicheOptions, setTechNicheOptions] = useState([]);
  const [editData, setEditData] = useState(null);
  const [requirement, setRequirement] = useState(false);
  const [resumeFile, setResumeFile] = useState(null);
  const [appliedResume, setAppliedResume] = useState(null);
  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      //   render: (text) => <p>{text}</p>,
    },
    {
      title: "Role",
      dataIndex: "role",
      key: "role",
    },
    {
      title: "EXP/Relevant",
      key: "EXP/Relevant",
      render: (_, record) => `${record.exp} year / ${record.relevantExp} year`,
    },
    {
      title: "Monthly Budget",
      dataIndex: "budget",
      key: "budget",
    },
    {
      title: "Mobile",
      dataIndex: "mobile",
      key: "mobile",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <div
          style={{
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            gap: "10px",
          }}
        >
          {(userData?.userRole == "company" ||
            userData?.permissions?.includes("apply_candidate")) && (
            <Tooltip title="Apply Candidate">
              <PlusOutlined
                onClick={() => {
                  setshowApplyModal(true);
                  setApplyRecord(record);
                }}
              />
            </Tooltip>
          )}
          {(userData?.userRole == "company" ||
            userData?.permissions?.includes("view_candidates")) && (
            <Tooltip title="View Detail">
              <svg
                width="24"
                height="16"
                viewBox="0 0 30 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                onClick={() => handleClick(record)}
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M14.2818 0.0159601C7.45391 0.319947 1.70525 4.93397 0.109432 11.136C0.03645 11.4196 0 11.7099 0 12C0 12.2901 0.0364637 12.5804 0.109432 12.864C1.68348 18.9815 7.29798 23.554 14.0032 23.9692C14.3329 23.9896 14.6654 24 15 24C22.14 24 28.2391 19.2824 29.8906 12.864C29.9636 12.5804 30 12.2901 30 12C30 11.7099 29.9636 11.4196 29.8906 11.136C28.2391 4.71767 22.14 0 15 0C14.7593 0 14.5199 0.00536006 14.2818 0.0159601ZM21.8182 12C21.8182 15.6819 18.7657 18.6667 15 18.6667C11.2345 18.6667 8.18186 15.6819 8.18186 12C8.18186 8.31811 11.2345 5.33333 15 5.33333C18.7657 5.33333 21.8182 8.31811 21.8182 12ZM15 16C17.2594 16 19.0909 14.2092 19.0909 12C19.0909 9.7908 17.2594 8 15 8C12.7407 8 10.9091 9.7908 10.9091 12C10.9091 14.2092 12.7407 16 15 16Z"
                  fill="#13487D"
                />
              </svg>
            </Tooltip>
          )}
          {(userData?.userRole == "company" ||
            userData?.permissions?.includes("update_candidates")) && (
            <Tooltip placement="top" title="Edit">
              <svg
                width="20"
                height="20"
                viewBox="0 0 28 28"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                onClick={() => handleEdit(record)}
              >
                <path
                  d="M16.625 13.608L11.6667 18.5663C11.2315 19.0003 10.6307 19.25 10.017 19.25H9.33333V18.5663C9.33333 17.9433 9.576 17.3577 10.017 16.9167L14.9753 11.9583L16.625 13.608ZM17.8418 9.09183L16.625 10.3087L18.2747 11.9583L19.4915 10.7415C19.9465 10.2865 19.9465 9.54683 19.4915 9.09183C19.0505 8.64967 18.2817 8.64967 17.8418 9.09183ZM28 5.83333V22.1667C28 25.3832 25.3832 28 22.1667 28H5.83333C2.61683 28 0 25.3832 0 22.1667V5.83333C0 2.61683 2.61683 0 5.83333 0H22.1667C25.3832 0 28 2.61683 28 5.83333ZM21.1423 7.44217C19.8193 6.12033 17.514 6.12033 16.1922 7.44217L8.36733 15.267C7.4865 16.1478 7 17.3203 7 18.5663V20.4167C7 21.0618 7.52267 21.5833 8.16667 21.5833H10.017C11.263 21.5833 12.4355 21.098 13.3163 20.216L21.1412 12.3912C22.5062 11.0262 22.5073 8.80717 21.1423 7.44217Z"
                  fill="#666666"
                />
              </svg>
            </Tooltip>
          )}
        </div>
      ),
    },
  ];
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [tableParams, setTableParams] = useState({
    page: 1,
    limit: 30,
    search: "",
  });
  const userData = useUserDetails();

  const handleClick = (record) => {
    setVisible(true);
    setModalData(record);
  };
  const fetchData = async () => {
    setLoading(true);
    try {
      let results = {};
      results = await postReq("company/candidate", tableParams);

      if (results.status === 200) {
        setData(results.data);
        setTotal(results.total);
        setLoading(false);
      } else {
        setData([]);
        setTotal(0);
        setLoading(false);
      }
    } catch (error) {
      toastNotification("error", error.message);
      setLoading(false);
    }
  };
  useEffect(() => {
    const timeout = setTimeout(() => {
      fetchData();
    }, 300);
    return () => clearTimeout(timeout);
  }, [tableParams.search, tableParams.page, tableParams.limit]);
  const handleTableChange = (pagination, filters, sorter) => {
    setTableParams((prev) => ({
      ...prev,
      page: pagination.current,
      limit: pagination.pageSize,
    }));

    if (pagination.pageSize !== tableParams.pagination?.pageSize) {
      setData([]);
    }
  };

  const handleCancle = () => {
    setVisible(false);
    setModalData({});
  };

  const handleOnChange = (e) => {
    setTableParams((prev) => ({ ...prev, search: e.target.value }));
  };

  const handleTagsData = async (isRequiredTech) => {
    try {
      let type = isRequiredTech ? "requiredTech" : "techNiche";

      const callResponse = await postReq("/common/getTags", {
        type: type,
      });

      if (callResponse.status == 1) {
        if (isRequiredTech) {
          //   setRequiredTechOptions(callResponse.data);
        } else {
          setTechNicheOptions(callResponse.data.tags);
        }
      }
    } catch (error) {
      console.log("error ", error);
    }
  };

  useEffect(() => {
    handleTagsData(false);
  }, []);

  const handleSubmit = async (values) => {
    try {
      const formData = new FormData();

      Object.entries(values).forEach(([key, val]) => {
        if (Array.isArray(val)) {
          console.log("key", key);
          formData.append(key, JSON.stringify(val));
        } else {
          formData.append(key, val);
        }
      });

      if (resumeFile) {
        formData.append("resume", resumeFile);
      }

      let postData;
      if (editData) {
        postData =
          userData?.userRole == "company"
            ? await postReq(
                `/company/update/candidate/${editData._id}`,
                formData,
                {
                  headers: {
                    "Content-Type": "multipart/form-data",
                  },
                },
              )
            : userData?.permissions.includes("add_candidates")
              ? await postReq(
                  `/common/update/candidate/${editData._id}`,
                  formData,
                  {
                    headers: {
                      "Content-Type": "multipart/form-data",
                    },
                  },
                )
              : { status: 201 };
      } else {
        postData =
          userData?.userRole == "company"
            ? await postReq("/company/create/candidate", formData, {
                headers: {
                  "Content-Type": "multipart/form-data",
                },
              })
            : userData?.permissions.includes("add_candidates")
              ? await postReq("/common/create/candidate", formData, {
                  headers: {
                    "Content-Type": "multipart/form-data",
                  },
                })
              : { status: 201 };
      }

      if (postData.status == 200) {
        fetchData();
        form.resetFields();
        setShowModal(false);
        setResumeFile(null);
        notification.success({
          message: "Success",
          description: `The Candidate ${
            editData ? "Updated" : "Created"
          } successful.`,
          placement: "topRight",
        });
      } else {
        form.resetFields();
        setShowModal(false);
        setResumeFile(null);
        notification.error({
          message: "Error",
          description:
            postData.message ||
            `There was an error ${
              editData ? "updating" : "creating"
            } Candidate.`,
          placement: "topRight",
        });
      }
    } catch (error) {
      console.log("error", error);
      setResumeFile(null);
      notification.error({
        message: "Error",
        description:
          error.message || "There was an error processing your request.",
        placement: "topRight",
      });
      form.resetFields();
      setShowModal(false);
    }
  };

  const handleEdit = (record) => {
    setShowModal(true);
    setEditData(record);
  };
  useEffect(() => {
    if (editData) {
      form.setFieldsValue({
        name: editData.name || "",
        role: editData.role || "",
        email: editData.email || "",
        mobile: editData.mobile || null,
        linkedin: editData.linkedin || "",
        location: editData.location || "",
        education: editData.education || "",
        technologyNiche: editData.technologyNiche.map((tech) => tech._id) || [],
        description: editData.description || "",
        exp: editData.exp || null,
        relevantExp: editData.relevantExp || null,
        budget: editData.budget || null,
        status: editData.status || "available",
      });
      setResumeFile(editData?.resume || null);
    } else {
      form.resetFields(); // clear when adding new
    }
  }, [editData, form]);

  const handleApplySubmit = async (values) => {
    try {
      const formData = new FormData();

      Object.entries(values).forEach(([key, val]) => {
        if (Array.isArray(val)) {
          console.log("key", key);
          formData.append(key, JSON.stringify(val));
        } else {
          formData.append(key, val);
        }
      });
      formData.append("candidateId", applyRecord._id);
      if (appliedResume) {
        formData.append("resume", appliedResume);
      }
      let postData;
      postData =
        userData?.userRole == "company"
          ? await postReq("/company/candidate/requirement", formData, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            })
          : userData.permissions.includes("apply_candidate")
            ? await postReq("/common/candidate/requirement", formData, {
                headers: {
                  "Content-Type": "multipart/form-data",
                },
              })
            : { status: 201 };

      if (postData.status == 200) {
        // fetchData();
        form.resetFields();
        setshowApplyModal(false);
        setAppliedResume(null);
        notification.success({
          message: "Success",
          description: `The Candidate attach to requirement successful.`,
          placement: "topRight",
        });
      } else {
        form.resetFields();
        setshowApplyModal(false);
        setAppliedResume(null);
        notification.error({
          message: "Error",
          description:
            postData.message ||
            `There was an error attching Candidate to requirement.`,
          placement: "topRight",
        });
      }
    } catch (error) {
      console.log("error");
      notification.error({
        message: "Error",
        description:
          error.message || "There was an error processing your request.",
        placement: "topRight",
      });
      setAppliedResume(null);
      form.resetFields();
      setShowModal(false);
    }
  };

  const fetchRequirement = async () => {
    const response = await postReq("company/requirement/drodown", {});

    if (response.status == 200) {
      setRequirement(response.data);
    } else {
      setRequirement(null);
    }
  };

  useEffect(() => {
    fetchRequirement();
  }, []);

  return (
    <>
      <Modal
        title={`Apply Candidate`}
        open={showApplyModal}
        onCancel={() => {
          setshowApplyModal(false);
          // setEditData(null);
        }}
        footer={
          <div style={{ paddingTop: "10px" }}>
            <Button
              type="default"
              // onClick={handleClear}
              style={{ marginRight: 8 }}
            >
              Reset
            </Button>
            <Button type="submit" onClick={() => form.submit()}>
              Submit
            </Button>
          </div>
        }
        width="70%" // Full width on moblepx
        style={{ top: 0 }}
        bodyStyle={{ padding: 10 }}
        responsive={true}
        className="responsive-modal"
      >
        <Form form={form} layout="vertical" onFinish={handleApplySubmit}>
          <Row gutter={16}>
            <Col xs={24} sm={12}>
              <Form.Item
                label="Select Requirement"
                name="requirementId"
                rules={[
                  { required: true, message: "Please select requirement type" },
                ]}
              >
                <Select
                  // mode="multiple"
                  placeholder="Select"
                  className="ant-select-selection1"
                  allowClear
                  maxTagCount="responsive"
                >
                  {requirement.length > 0 &&
                    requirement.map((data, i) => (
                      <Option key={i} value={`${data._id}`}>
                        {data.requirementName} - {data.jobId}
                      </Option>
                    ))}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item
                label="Monthly Budget"
                name="budget"
                rules={[
                  {
                    required: true,
                    message: "Please enter monthly budget",
                  },
                ]}
              >
                <InputNumber
                  maxLength={7}
                  placeholder="Enter"
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col xs={24} sm={24}>
              <Form.Item label="Description." name="description">
                <Input.TextArea
                  maxLength={4000}
                  style={{ height: 100, resize: "vertical" }}
                  placeholder="Enter"
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col xs={24} sm={12}>
              <Form.Item
                label="Experience"
                name="experience"
                rules={[
                  {
                    required: true,
                    message: "Please enter experience",
                  },
                ]}
              >
                <InputNumber
                  maxLength={7}
                  placeholder="Enter"
                  style={{ width: "100%" }}
                  min={0}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item
                label="Resume"
                rules={[{ required: true, message: "Resume is required." }]}
              >
                <Upload
                  accept=".pdf,.doc,.docx"
                  maxCount={1}
                  beforeUpload={() => false} // prevent auto upload
                  onChange={(info) => {
                    const file = info.fileList[0]?.originFileObj;
                    setAppliedResume(file || null);
                  }}
                >
                  <Button icon={<UploadOutlined />}>Upload Resume</Button>
                </Upload>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
      <Modal
        title="Candidate Details"
        open={visible}
        onCancel={handleCancle}
        width={900}
        bodyStyle={{ padding: "24px" }}
        headerStyle={{
          backgroundColor: "#F4F4F4",
        }}
        footer={null} // No footer
      >
        <Row gutter={[16, 16]}>
          <Col span={12}>
            <Descriptions bordered column={1} size="middle">
              <Descriptions.Item label="Name">
                {modalData.name}
              </Descriptions.Item>
              <Descriptions.Item label="Email">
                {modalData.email}
              </Descriptions.Item>
              <Descriptions.Item label="Mobile Number">
                {modalData?.mobile || ""}
              </Descriptions.Item>
              <Descriptions.Item label="Education">
                {modalData?.education || ""}
              </Descriptions.Item>
              <Descriptions.Item label="Monthly Budget">
                {modalData?.budget || ""}
              </Descriptions.Item>
              <Descriptions.Item label="Role">
                {modalData.role}
              </Descriptions.Item>
              <Descriptions.Item label="Exp">
                {modalData?.exp || ""}
              </Descriptions.Item>
              <Descriptions.Item label="Relevant Exp">
                {modalData?.relevantExp || ""}
              </Descriptions.Item>
            </Descriptions>
          </Col>
          <Col span={12}>
            <Descriptions bordered column={1} size="middle">
              <Descriptions.Item label="Location">
                {modalData.location}
              </Descriptions.Item>
              <Descriptions.Item label="Linked In">
                <a
                  href={`${modalData.linkedin}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {modalData.linkedin}
                </a>
              </Descriptions.Item>
              <Descriptions.Item label="Tech">
                {modalData?.technologyNiche?.map((data) => (
                  <Tag>{data.value}</Tag>
                ))}
              </Descriptions.Item>

              <Descriptions.Item label="Description">
                {modalData.description} {modalData.description}{" "}
                {modalData.description} {modalData.description}{" "}
                {modalData.description} {modalData.description}{" "}
                {modalData.description}
              </Descriptions.Item>
              <Descriptions.Item label="Resume">
                <a
                  href={`https://rmt.cloudstakes.com/api/files/${modalData?.resume}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {modalData?.resume}
                </a>
              </Descriptions.Item>
            </Descriptions>
          </Col>
        </Row>
      </Modal>
      <Modal
        title={`${editData ? "Edit" : "Add"} Candidate`}
        open={showModal}
        onCancel={() => {
          setShowModal(false);
          setEditData(null);
        }}
        footer={
          <div style={{ paddingTop: "10px" }}>
            <Button
              type="default"
              // onClick={handleClear}
              style={{ marginRight: 8 }}
            >
              Reset
            </Button>
            <Button type="primary" onClick={() => form.submit()}>
              {`${editData ? "Update" : "Submit"}`}
            </Button>
          </div>
        }
        width="70%" // Full width on moblepx
        style={{ top: 0 }}
        bodyStyle={{ padding: 10 }}
        responsive={true}
        className="responsive-modal"
      >
        <Form form={form} layout="vertical" onFinish={handleSubmit}>
          <Row gutter={16}>
            <Col xs={24} sm={12}>
              <Form.Item
                label="Name"
                name="name"
                rules={[
                  {
                    required: true,
                    message: "Please enter name",
                  },
                ]}
              >
                <Input maxLength={40} placeholder="Enter" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item
                label="Role"
                name="role"
                rules={[
                  {
                    required: true,
                    message: "Please enter Role",
                  },
                ]}
              >
                <Input maxLength={40} placeholder="Enter Role" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col xs={24} sm={12}>
              <Form.Item
                label="Email"
                name="email"
                rules={[
                  {
                    required: true,
                    message: "Please enter candidate Email",
                  },
                ]}
              >
                <Input maxLength={40} placeholder="Enter Email" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item
                label="Phone"
                name="mobile"
                rules={[
                  {
                    required: true,
                    message: "Please enter Mobile Number.",
                  },
                  {
                    pattern: /^[0-9]{10}$/,
                    message: "Mobile number must be exactly 10 digits.",
                  },
                ]}
              >
                <InputNumber
                  maxLength={10}
                  placeholder="Enter Mobile Number."
                  type="tel"
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col xs={24} sm={12}>
              <Form.Item
                label="Linkedin"
                name="linkedin"
                rules={[
                  {
                    required: true,
                    message: "Please enter linkedin URI",
                  },
                ]}
              >
                <Input maxLength={100} placeholder="Enter linkedin" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item
                label="Location"
                name="location"
                rules={[
                  {
                    required: true,
                    message: "Please enter Location.",
                  },
                ]}
              >
                <Input maxLength={40} placeholder="Enter Location." />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col xs={24} sm={12}>
              <Form.Item
                label="Education"
                name="education"
                rules={[
                  {
                    required: true,
                    message: "Please enter Education.",
                  },
                ]}
              >
                <Input maxLength={100} placeholder="Enter Education." />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item
                label="Select Technology"
                name="technologyNiche"
                rules={[
                  { required: true, message: "Please select requirement type" },
                ]}
              >
                <Select
                  mode="multiple"
                  placeholder="Select"
                  className="ant-select-selection1"
                  allowClear
                  maxTagCount="responsive"
                >
                  {techNicheOptions.length > 0 &&
                    techNicheOptions.map((data, i) => (
                      <Option key={i} value={`${data._id}`}>
                        {data.value}
                      </Option>
                    ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col xs={24} sm={24}>
              <Form.Item label="Description." name="description">
                <Input.TextArea
                  maxLength={4000}
                  style={{ height: 100, resize: "vertical" }}
                  placeholder="Enter"
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col xs={24} sm={6}>
              <Form.Item
                label="Total Exp"
                name="exp"
                rules={[
                  {
                    required: true,
                    message: "Please enter Total Exp",
                  },
                ]}
              >
                <InputNumber
                  maxLength={40}
                  placeholder="Enter EXP."
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={6}>
              <Form.Item
                label="Relevant Exp"
                name="relevantExp"
                rules={[
                  {
                    required: true,
                    message: "Please enter Relevant Exp.",
                  },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || value <= getFieldValue("exp")) {
                        return Promise.resolve();
                      }
                      return Promise.reject(
                        new Error(
                          "Relevant Exp cannot be greater than Total Exp",
                        ),
                      );
                    },
                  }),
                ]}
              >
                <InputNumber
                  maxLength={40}
                  placeholder="Enter Relevant EXP."
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={6}>
              <Form.Item
                label="Monthly Budget"
                name="budget"
                rules={[
                  {
                    required: true,
                    message: "Please enter Monthly Budget",
                  },
                ]}
              >
                <InputNumber
                  maxLength={40}
                  placeholder="Enter budget"
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={6}>
              <Form.Item
                label="Select Status"
                name="status"
                rules={[{ required: true, message: "Please select status" }]}
              >
                <Select placeholder="Select" className="ant-select-selection1">
                  {[
                    { value: "available", label: "Available" },
                    { value: "on_project", label: "On Project" },
                    { value: "not_available", label: "Not Available" },
                  ].map((data, i) => (
                    <Option key={i} value={data.value}>
                      {data.label}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col xs={24} sm={12}>
              <Form.Item
                label="Resume"
                rules={[{ required: true, message: "Resume is required." }]}
              >
                {resumeFile && typeof resumeFile === "string" ? (
                  // 🟢 Show existing file with link in edit mode
                  <div>
                    <a
                      href={`https://rmt.cloudstakes.com/api/files/${resumeFile}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {resumeFile}
                    </a>
                    <Button
                      type="link"
                      onClick={() => setResumeFile(null)}
                      style={{ paddingLeft: 8 }}
                    >
                      Replace
                    </Button>
                  </div>
                ) : (
                  // 🟢 Show upload button (add or replace)
                  <Upload
                    accept=".pdf,.doc,.docx"
                    maxCount={1}
                    beforeUpload={() => false} // prevent auto upload
                    onChange={(info) => {
                      const file = info.fileList[0]?.originFileObj;
                      setResumeFile(file || null);
                    }}
                  >
                    <Button icon={<UploadOutlined />}>Upload Resume</Button>
                  </Upload>
                )}
                {/* <Upload
                  accept=".pdf,.doc,.docx"
                  maxCount={1}
                  beforeUpload={() => false} // Prevent auto-upload
                  onChange={(info) => {
                    const file = info.fileList[0]?.originFileObj;
                    setResumeFile(file || null);
                  }}
                >
                  <Button icon={<UploadOutlined />}>Upload Resume</Button>
                </Upload> */}
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
      <Card
        title={
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "16px",
              borderRadius: "20px 20px 0px 0px",
              margin: "0px -24px",
            }}
          >
            <div>
              <Title
                level={4}
                style={{
                  marginBottom: 0,
                  fontSize: "20px",
                  fontWeight: "800",
                  color: "#13487D",
                }}
              >
                Candidates
              </Title>
              {/* <Text type="secondary" style={{ fontSize: "14px" }}>
                Dedicated Project
              </Text> */}
            </div>

            <div style={{ display: "inline-flex", gap: "8px" }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  backgroundColor: "#F4F4F4",
                  borderRadius: "10px",
                  // padding: "10px 16px",
                  width: "300px",
                  boxShadow: "0px 1px 5px rgba(0,0,0,0.1)",
                }}
              >
                <Input
                  placeholder="Search By Candidate Name"
                  bordered={false}
                  onChange={handleOnChange}
                  style={{
                    fontSize: "16px",
                    color: "#6F6F6F",
                    border: "none",
                  }}
                />
                <svg
                  width="44"
                  height="44"
                  viewBox="0 0 64 64"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  onClick={() => setIsSearch(!isSearch)}
                >
                  <rect width="64" height="64" rx="18" fill="#F4F4F4" />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M35.2267 37.1801L40.6511 42.5978C41.1882 43.1342 42.0603 43.134 42.5974 42.5975C43.1343 42.0607 43.1342 41.1893 42.5971 40.6527L37.1763 35.2389C38.2668 33.757 38.9114 31.9269 38.9114 29.9476C38.9114 25.0092 34.8985 21 29.9557 21C25.0129 21 21 25.0092 21 29.9476C21 34.8859 25.0129 38.8951 29.9557 38.8951C31.9255 38.8951 33.7474 38.2586 35.2267 37.1801ZM29.9557 23.7501C33.3793 23.7501 36.159 26.5271 36.159 29.9476C36.159 33.3681 33.3793 36.1452 29.9557 36.1452C26.5321 36.1452 23.7526 33.3681 23.7526 29.9476C23.7526 26.5271 26.5321 23.7501 29.9557 23.7501Z"
                    fill="#13487D"
                  />
                </svg>
              </div>
              {/* )} */}
              {(userData?.userRole == "company" ||
                userData?.permissions?.includes("add_candidates")) && (
                <svg
                  width="44"
                  height="44"
                  viewBox="0 0 64 64"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  onClick={() => setShowModal(true)}
                  style={{ cursor: "pointer" }}
                >
                  <rect width="64" height="64" rx="18" fill="#F4F4F4" />
                  <path
                    d="M32 22V42"
                    stroke="#13487D"
                    stroke-width="2.7"
                    stroke-linecap="round"
                  />
                  <path
                    d="M42 32L22 32"
                    stroke="#13487D"
                    stroke-width="2.7"
                    stroke-linecap="round"
                  />
                </svg>
              )}
            </div>
          </div>
        }
        style={{
          paddingLeft: "16px",
          color: "#13487D",
          borderRadius: "18px",
          maxWidth: "100%",
          overflow: "hidden",
        }}
        bordered={false}
      >
        <Table
          columns={columns}
          dataSource={data}
          pagination={{
            current: tableParams.page,
            pageSize: tableParams.limit,
            total,
            showSizeChanger: true,
            pageSizeOptions: [5, 10, 20, 30],
            // position: ["bottomCenter"],
            itemRender: (current, type, originalElement) => {
              if (type === "prev") {
                return <a>Prev</a>;
              }
              if (type === "next") {
                return <a>Next</a>;
              }
              return originalElement;
            },
            showTotal: (total, range) => (
              <span style={{ color: "#6b7280" }}>
                Showing {range[0]}–{range[1]} of {total}
              </span>
            ),
          }}
          loading={loading}
          scroll={{ x: "max-content" }}
          onChange={handleTableChange}
        />
      </Card>
    </>
  );
};

export default Candidate;
